import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const EmailTopicItems = ({
  topics,
  selectedTicket,
  handleSelectTicket,
}: any) => {
  const { ticketNumber, unreadMessages, title, lastUpdate, id } = topics || {};

  return (
    <Box
      sx={{
        borderBottom: "1px solid #E9E9E9",
        padding: "20px 10px 30px 20px",
        background:
          selectedTicket === id ? "rgba(40, 88, 211, 0.1)" : "#FFFFFF",
        cursor: "pointer",
      }}
      onClick={() => handleSelectTicket(id)}
    >
      <Box display="flex" justifyContent="space-between">
        <Box>
          <Typography
            sx={{
              color: "#3D4043",
              fontSize: "14px",
            }}
          >
            {ticketNumber}
          </Typography>
        </Box>
        {unreadMessages && (
          <Box
            display="flex"
            sx={{
              background: "#EB6C6C",
              padding: "3px 7px",
              borderRadius: "100px",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
                fontWeight: 400,
              }}
            >
              {unreadMessages} unread
            </Typography>
          </Box>
        )}
      </Box>

      <Box
        sx={{
          marginTop: "5px",
        }}
      >
        <Typography
          sx={{
            maxWidth: "200px",
            color: selectedTicket === id ? "#2858D3" : "#3D4043",
            fontWeight: 600,
            fontSize: 18,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box>
        <Typography
          sx={{
            color: "#3D4043",
            opacity: 0.5,
            fontSize: "14px",
          }}
        >
          Last updated on {lastUpdate}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmailTopicItems;
